(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  function cleanIuteText() {
    document.querySelectorAll('.iute-card-widget .iute-promo-text').forEach(function(el) {
      if (el.dataset.cleaned) return;
      el.dataset.cleaned = '1';
      // Get raw text, strip &nbsp; and trim
      var raw = el.innerText.replace(/ /g, '').trim();
      // Extract only "Duke Filluar nga XXXL/muaj" — drop "0% APR me" and logo
      var match = raw.match(/Duke\s+Filluar\s+nga\s+([\d,\.]+\s*L\/muaj)/i);
      if (match) {
        el.innerHTML =
          '<span class="iute-promo-label">Duke filluar nga </span>' +
          '<span class="iute-promo-amount">' + match[1] + '</span>';
      } else {
        // fallback: just strip logo and APR text
        el.innerHTML = el.innerHTML
          .replace(/<span[^>]*iute-promo-logo[^>]*>.*?<\/span>/gi, '')
          .replace(/0%\s*APR\s*me/gi, '')
          .replace(/&nbsp;/g, '')
          .trim();
      }
    });
  }
  new MutationObserver(cleanIuteText).observe(document.body, { childList: true, subtree: true });
  cleanIuteText();
});
  } catch(e) { console.error(e); }
})();

})();
